import $ from "jquery";
import { throttle } from "throttle-debounce";

const setfixedHeader = function () {
  if ($(window).scrollTop() > 0) {
    $("body").addClass("is-header-fixed");
  } else {
    $("body").removeClass("is-header-fixed");
  }
};

const handleScroll = throttle(200, () => {
  setfixedHeader();
});

$(function () {
  setfixedHeader();
  $(window).on("scroll", handleScroll);
});
